import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class GKVKComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
